angular.module('pl-shared')
  .filter('numberToPercent', function($filter) {
    return function(input, decimalPlaces) {
      if (!input) return
      decimalPlaces = parseInt(decimalPlaces, 10) || 0
      return $filter('number')(input * 100, decimalPlaces) + '%'
    }
  })
